exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ee-icon-svg {\n    fill: currentColor;\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n}\n", ""]);

// exports
